import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useParams } from "react-router";
import InputComponent from "../../AddCustomers/InputComponent";
import Plus from "../../AddCustomers/Icons/Add.svg";
import Minus from "../../AddCustomers/Icons/minus.svg";
import middleware from "../../../Api/Middleware";
import ToastError from "../../../Toasts/ToastError";
import LoadingScreen from "../../../LoadingScreen/LoadingScreen";
import ToastSuccess from "../../../Toasts/ToastSuccess";
import { useTable } from "react-table";
import TablePreset from "../../../Table/TablePreset";
import Trash from "../Icons/trash-can.svg";
import Pin from "../Icons/thumbtack-solid.svg";
import CancelPin from "../Icons/thumbtack-slash-solid.svg";
import editIcon from "../Icons/pen-to-square-solid.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddContactsModal from "../CustomerModals/AddContactsModal";
import {
  BorderedTextInput,
  RegularTextInput,
} from "../../../HouseStyle/Components/Inputs";
import { BorderedDropDown } from "../../../HouseStyle/Components/DropDowns";
import {format, parseISO} from "date-fns";
import Phonenumber from "../../Components/Phonenumber";

const GeneralInfoTab = ({
  typeCustomer,
  setDataUpdated,
  dataUpdated,
  setConsumerInfoUpdated,
}) => {
  const { internal_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [consumerData, setConsumerData] = useState([]);
  const [businessInfo, setBusinessInfo] = useState({});
  const [emailSettings, setEmailSettings] = useState({});
  const [emails, setEmails] = useState([]);
  const [adress, setAdress] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);
  const [removedEmails, setRemovedEmails] = useState([]); // State for removed emails
  const [phoneNumbers, setPhoneNumbers] = useState([{}]);
  const [removedPhoneNumbers, setRemovedPhoneNumbers] = useState([]); // State for removed phone numbers
  const [showAddContactsModal, setShowAddContactsModal] = useState(false);
  const [initialData, setInitialData] = useState({});
  const [formData, setFormData] = useState({
    phone_numbers: [],
    emails: []
  });
  const timerRef = useRef(null);
  const [rowToEdit, setRowToEdit] = useState(null);
  const [updatedContacts, setUpdatedContacts] = useState(false);
  const formRef = useRef(null); // Step 1: Create a ref for the form
  const vatPatterns = {
    AT: /^ATU\d{8}$/, // Austria
    BE: /^BE0\d{9}$/, // Belgium
    BG: /^BG\d{9,10}$/, // Bulgaria
    CY: /^CY\d{8}[A-Z]$/, // Cyprus
    CZ: /^CZ\d{8,10}$/, // Czech Republic
    DE: /^DE\d{9}$/, // Germany
    DK: /^DK\d{8}$/, // Denmark
    EE: /^EE\d{9}$/, // Estonia
    EL: /^EL\d{9}$/, // Greece
    ES: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/, // Spain
    FI: /^FI\d{8}$/, // Finland
    FR: /^FR[A-Z0-9]{2}\d{9}$/, // France
    GB: /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/, // United Kingdom
    HR: /^HR\d{11}$/, // Croatia
    HU: /^HU\d{8}$/, // Hungary
    IE: /^IE\d[A-Z0-9+*]\d{5}[A-Z]$/, // Ireland
    IT: /^IT\d{11}$/, // Italy
    LT: /^LT(\d{9}|\d{12})$/, // Lithuania
    LU: /^LU\d{8}$/, // Luxembourg
    LV: /^LV\d{11}$/, // Latvia
    MT: /^MT\d{8}$/, // Malta
    NL: /^NL\d{9}B\d{2}$/, // Netherlands
    PL: /^PL\d{10}$/, // Poland
    PT: /^PT\d{9}$/, // Portugal
    RO: /^RO\d{2,10}$/, // Romania
    SE: /^SE\d{12}$/, // Sweden
    SI: /^SI\d{8}$/, // Slovenia
    SK: /^SK\d{10}$/, // Slovakia
    // Add more countries as needed
  };
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  });
  useEffect(() => {
    if (!loading) {
      fetchContacts();
      setUpdatedContacts(false);
    }
  }, [pagination.page, pagination.page_size, updatedContacts]);
  const fetchContacts = async () => {
    try {
      const [noteRes] = await Promise.all([
        middleware.get(
          `businessescontacts?internal_id=${internal_id}&page_size=${pagination.page_size}&page=${pagination.page}&orderBy=created_at&direction=desc`
        ),
      ]);
      setConsumerData(noteRes.data.data.data);
      setPagination({
        ...pagination,
        max_items: noteRes.data.data.total,
        begin_of_page: noteRes.data.data.from,
        end_of_page: noteRes.data.data.to,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCorrectConsumer = async (internalId) => {
    if (internalId) {
      setLoading(true);
      try {
        let initialData = {};
        if (internalId.startsWith("B")) {
          const [
            businessResponse,
            businessContactResponse,
            emailRes,
            phoneNumberRes,
            emailSettingsRes,
          ] = await Promise.all([
            middleware.get(`businesses?internal_id=${internalId}`),
            middleware.get(
              `businessescontacts?internal_id=${internalId}&page_size=${pagination.page_size}&page=${pagination.page}&orderBy=created_at`
            ),
            middleware.get(`emails?internal_id=${internalId}`),
            middleware.get(`phonenumbers?internal_id=${internalId}`),
            middleware.get(`emailsettings?internal_id=${internalId}`),
          ]);

          setBusinessInfo(
            businessResponse.data[0] ?? {
              cocnumber: "",
              company_id: "",
              company_name: "",
              fax_number: "",
              has_loyalty: 0,
              internal_id: internal_id,
              invoicemail: "",
              loyaltypoints: "",
              loyalty_signup_date: "",
              permanent_sale: "",
              status: "",
              url: "",
              vatnumber: "",
            }
          );
          setConsumerData(businessContactResponse.data.data.data.map(contact => ({
            ...contact,
            birthday: contact.birthday ? format(parseISO(contact.birthday), "dd-MM-yyyy") : ""
          })));
          setPagination({
            ...pagination,
            max_items: businessContactResponse.data.data.total,
            begin_of_page: businessContactResponse.data.data.from,
            end_of_page: businessContactResponse.data.data.to,
          });

          setEmails(emailRes.data.data);
          setPhoneNumbers(phoneNumberRes.data.data);
          setEmailSettings(emailSettingsRes.data.data[0]);

          initialData = {
            business: businessResponse.data.data[0] ?? {
              cocnumber: "",
              company_id: "",
              company_name: "test",
              fax_number: "",
              has_loyalty: 0,
              internal_id: internal_id,
              invoicemail: "",
              loyaltypoints: "",
              loyalty_signup_date: "",
              permanent_sale: "",
              status: "",
              url: "",
              vatnumber: "",
            },
            business_contact: businessContactResponse.data.data,
            emails: emailRes.data.data,
            phone_numbers: phoneNumberRes.data.data,
            email_settings: emailSettingsRes.data.data[0],
          };
        } else if (internalId.startsWith("C")) {
          const [consumerResponse, emailRes, phoneNumberRes, emailSettingsRes] =
            await Promise.all([
              middleware.get(`consumers?internal_id=${internalId}`),
              middleware.get(`emails?internal_id=${internalId}`),
              middleware.get(`phonenumbers?internal_id=${internalId}`),
              middleware.get(`emailsettings?internal_id=${internalId}`),
            ]);

          setConsumerData(consumerResponse.data.data[0]);
          setEmails(emailRes.data.data);
          setPhoneNumbers(phoneNumberRes.data.data);
          setEmailSettings(emailSettingsRes.data.data[0]);

          initialData = {
            consumer: consumerResponse.data.data[0],
            emails: emailRes.data.data,
            phone_numbers: phoneNumberRes.data.data,
            email_settings: emailSettingsRes.data.data[0],
          };
        }
        const [adressesResponse, countrycodesResponses] = await Promise.all([
          middleware.get(`addresses?internal_id=${internalId}`),
          middleware.get(`countryCodes`),
        ]);
        if (adressesResponse.data.length) {
          countrycodesResponses.data.forEach((countrycode) => {
            if (
              countrycode.country_code_id ==
              adressesResponse.data[0].country_code_id
            ) {
              setCountryCodes(countrycode);
            }
          });
        }
        setInitialData(initialData);
        setFormData(structuredClone(initialData)); // Initialize formData with a deep copy of initial data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCorrectConsumer(internal_id);
  }, [dataUpdated]);
  const updateNestedFormData = useCallback((key, value, fieldType) => {
    setFormData((prev) => ({
      ...prev,
      [fieldType]: {
        ...structuredClone(prev[fieldType]), // Clone the nested object to avoid mutating the original
        [key]: value,
      },
    }));
  }, []);

  const getValueInput = useCallback(
    (value, label) => {
      if (label === "vatnumber") {
        if (!validateVATNumber(countryCodes.country_code_2, value)) {
          ToastError("BTW-nummer is niet geldig voor het geselecteerde land");
          return; // Stop further processing if VAT number is invalid
        }
      }

      if (label in businessInfo) {
        updateNestedFormData(label, value, "business");
      } else if (label in consumerData) {
        updateNestedFormData(label, value, "consumer");
      } else if (label in emailSettings) {
        updateNestedFormData(label, value, "email_settings");
      } else if (label in consumerData) {
        updateNestedFormData(label, value, "birthday");
      }
    },
    [businessInfo, consumerData, emailSettings, countryCodes]
  );

  const handleBlurInput = useCallback(
    (value, label) => {
      if (label === "vatnumber") {
        if (!validateVATNumber(countryCodes.country_code_2, value)) {
          ToastError("BTW-nummer is niet geldig voor het geselecteerde land.");
          return; // Stop further processing if VAT number is invalid
        }
      }

      if (label in businessInfo) {
        updateNestedFormData(label, value, "business");
      } else if (label in consumerData) {
        updateNestedFormData(label, value, "business_contact");
      } else if (label in emailSettings) {
        updateNestedFormData(label, value, "email_settings");
      } else if (label in consumerData) {
        updateNestedFormData(label, value, "birthday");
      }
    },
    [businessInfo, consumerData, emailSettings, countryCodes]
  );

  const handleSubmit = useCallback(async () => {
    const changedData = {};
    if (formData.emails != null) {
      const newEmails = formData.emails.filter((email) => !email.email_id); // Detect new emails without ID
      const newPhoneNumbers = formData.phone_numbers.filter(
        (phone) => !phone.phone_number_id
      ); // Detect new phone numbers without ID

      // Handle changes in existing data
      if (typeCustomer === "B") {
        if (
          JSON.stringify(initialData.business) !==
          JSON.stringify(formData.business)
        ) {
          changedData.business = formData.business;
        }
        if (
          JSON.stringify(initialData.business_contact) !==
          JSON.stringify(formData.business_contact)
        ) {
          changedData.business_contact = formData.business_contact;
        }
      } else if (typeCustomer === "C") {
        if (
          JSON.stringify(initialData.consumer) !==
          JSON.stringify(formData.consumer)
        ) {
          changedData.consumer = formData.consumer;
        }
      }
      if (
        JSON.stringify(initialData.emails) !== JSON.stringify(formData.emails)
      ) {
        changedData.emails = formData.emails.filter((email) => email.email_id); // Only include existing emails
      }

      if (
        JSON.stringify(initialData.phone_numbers) !==
        JSON.stringify(formData.phone_numbers)
      ) {
        changedData.phone_numbers = formData.phone_numbers.filter(
          (phone) => phone.phone_number_id
        ); // Only include existing phone numbers
      }

      let hasError = false;
      try {
        // Send POST requests for new emails and phone numbers
        if (newEmails.length > 0) {
          for (const newEmail of newEmails) {
            if (newEmail.email !== undefined && newEmail.email.trim() !== "") {
              try {
                const res = await middleware.post(`emails`, {
                  internal_id,
                  email: newEmail.email,
                });

                const emails = await middleware.get(
                  `emails?internal_id=${internal_id}`
                );
                setFormData({ ...formData, emails: emails.data.data });
                setEmails(emails.data.data);
              } catch (error) {
                hasError = true;
                ToastError("Email formaat is ongeldig");
                console.error(error);
              }
            } else {
              hasError = true;
            }
          }
        }
        if (newPhoneNumbers.length > 0) {
  for (const newNumber of newPhoneNumbers) {
    if (
      newNumber.phone_number !== undefined && 
      newNumber.phone_number.trim() !== "" &&
      validatePhoneNumber(newNumber.phone_number)
    ) {
      try {
        const res = await middleware.post(`phonenumbers`, {
          internal_id,
          phone_number: Number(newNumber.phone_number),
          country_phone_prefix: newNumber.country_phone_prefix,
          fullnumber:
            "+" +
            newNumber.country_phone_prefix +
            "-" +
            Number(newNumber.phone_number),
        });
        let phones = await middleware.get(
          `phonenumbers?internal_id=${internal_id}`
        );

        setFormData({ ...formData, phone_numbers: phones.data.data });
        setPhoneNumbers(phones.data.data);
      } catch (error) {
        hasError = true;
        ToastError("Telefoonummer format is incorrect");
        console.error(error);
      }
    } else {
      hasError = true;
      ToastError("Telefoonummer format is incorrect");
    }
  }
}

        if (typeCustomer === 'B' && !/^NL\d{9}B\d{2}$/.test(formData.business.vatnumber)) {
          hasError = true;
          ToastError("BTW nummer formaat is ongeldig");
        }

        // Handle PUT requests for existing data
        if (Object.keys(changedData).length > 0) {
          if (changedData.business) {
              const { contact_persons, ...payload } = changedData.business; //haal contact_persons uit de payload
            await middleware.put(
              `businesses?internal_id=${internal_id}`,
              payload
            );
          }
          if (changedData.business_contact) {
            await middleware.put(
              `businessescontacts?internal_id=${internal_id}`,
              changedData.business_contact
            );
          }
          if (changedData.consumer) {
            await middleware.put(
              `consumers?internal_id=${internal_id}`,
              changedData.consumer
            );
          }
          if (changedData.emails) {
            await Promise.all(
              changedData.emails.map((email) =>
                middleware
                  .put(`emails?internal_id=${internal_id}`, {
                    email_id: email.email_id,
                    email: email.email,
                  })
                  .catch((error) => {
                    hasError = true;
                    ToastError("Email formaat is ongeldig");
                  })
              )
            );
          }
          if (changedData.phone_numbers) {
            await Promise.all(
              changedData.phone_numbers.map((phone_number) =>
                middleware
                  .put(`phonenumbers?internal_id=${internal_id}`, {
                    phone_number_id: phone_number.phone_number_id,
                    phone_number: Number(phone_number.phone_number),
                    country_phone_prefix: phone_number.country_phone_prefix,
                    fullnumber:
                      "+" +
                      phone_number.country_phone_prefix +
                      "-" +
                      Number(phone_number.phone_number),
                  })
                  .catch((error) => {
                    hasError = true;
                    ToastError(`Telefoonnummer is ongeldig`);
                  })
              )
            );
          }
        }

        // Check for errors before showing success message
        if (hasError) {
        } else if (
          Object.keys(changedData).length > 0 ||
          newEmails.length > 0 ||
          newPhoneNumbers.length > 0
        ) {
          ToastSuccess("Veranderingen successvol opgeslagen!");
          // Update initialData to reflect the new state after save
          setInitialData(structuredClone(formData));
          setConsumerInfoUpdated(true);
        }

        // // Refetch the data to get the updated data including newly created IDs
      } catch (error) {
        console.error("Error submitting data:", error);
        ToastError("Error submitting data.");
      }
    }
  }, [formData, initialData, typeCustomer, internal_id]);

  const addEmailField = () => {
    if (emails.length < 3) {
      setEmails([...emails, ""]);
    } else {
      ToastError("Je kunt maximaal 3 e-mailadressen toevoegen");
    }
  };

  const handleEmailChange = (index, value) => {
    const newEmails = structuredClone(emails);

    if (value.includes(' ')) return;
    if (typeof newEmails[index] === "object") {
      newEmails[index].email = value;
    } else {
      newEmails[index] = { email: value };
    }
    setEmails(newEmails);
    setFormData((prev) => ({
      ...prev,
      emails: newEmails,
    }));
  };

  const handleEmailBlur = (index, value) => {
    const newEmails = structuredClone(emails);
    if (typeof newEmails[index] === "object") {
      newEmails[index].email = value;
    } else {
      newEmails[index] = { email: value };
    }
    setEmails(newEmails);
    setFormData((prev) => ({
      ...prev,
      emails: newEmails,
    }));
  };

  const removeEmailField = async (index) => {
    const confirmDelete = window.confirm(
      "Weet je zeker dat je deze e-mail wilt verwijderen?"
    );
    if (confirmDelete) {
      const emailToRemove = emails[index];

      if (emailToRemove.email_id) {
        // Only delete if the email has an ID
        try {
          await middleware.delete(`/emails?email_id=${emailToRemove.email_id}`);
          ToastSuccess("E-mail succesvol verwijderd!");
          setConsumerInfoUpdated(true);
        } catch (error) {
          console.error("Error deleting email:", error);
          ToastError(
            "Er is een fout opgetreden bij het verwijderen van de e-mail."
          );
          return;
        }
      }

      // Update state after successful deletion
      const newEmails = emails.filter((_, i) => i !== index);
      setEmails(newEmails);
      setFormData((prev) => ({
        ...prev,
        emails: newEmails,
      }));
    }
  };

  const validateVATNumber = (countryCode, vatNumber) => {
    const pattern = vatPatterns[countryCode];
    if (!pattern) {
      return /^(?=.{0,18}$)[0-9A-Za-z]*$/.test(vatNumber);
    }
    return pattern.test(vatNumber);
  };

  const validatePhoneNumber = (phoneNumber) => {
  return /^\d{7,}$/.test(phoneNumber);
};

  const addPhoneNumberField = () => {
    if (phoneNumbers.length < 3) {
      const lastPhoneNumber = phoneNumbers[phoneNumbers.length - 1];
      const defaultPrefix = lastPhoneNumber?.country_phone_prefix || "31";
      setPhoneNumbers([...phoneNumbers, { country_phone_prefix: defaultPrefix }]);
    } else {
      ToastError("Je kunt maximaal 3 telefoonnummers toevoegen");
    }
  };

const handlePhoneNumberChange = (index, value) => {
  // Only allow numeric input
  if (!/^\d*$/.test(value)) return;
  
  const newPhoneNumbers = structuredClone(phoneNumbers);
  if (typeof newPhoneNumbers[index] === "object") {
    newPhoneNumbers[index].phone_number = value;
  } else {
    newPhoneNumbers[index] = { phone_number: value };
  }
  setPhoneNumbers(newPhoneNumbers);
  setFormData((prev) => ({
    ...prev,
    phone_numbers: newPhoneNumbers,
  }));
};
  
  const setPhoneCode = (index, value) => {
    const newPhoneNumbers = structuredClone(phoneNumbers); // Create a deep copy to avoid mutating initialData
    if (typeof newPhoneNumbers[index] === "object") {
      newPhoneNumbers[index].country_phone_prefix = value;
      newPhoneNumbers[index].code_index = value;
    }
    setPhoneNumbers(newPhoneNumbers);
    setFormData((prev) => ({
      ...prev,
      phone_numbers: newPhoneNumbers,
    }));
  };

  const handlePhoneNumberBlur = (index, value) => {
    const newPhoneNumbers = structuredClone(phoneNumbers); // Create a deep copy to avoid mutating initialData
    if (typeof newPhoneNumbers[index] === "object") {
      newPhoneNumbers[index].phone_number = value;
    } else {
      newPhoneNumbers[index] = { phone_number: value };
    }
    setPhoneNumbers(newPhoneNumbers);
    setFormData((prev) => ({
      ...prev,
      phone_numbers: newPhoneNumbers,
    }));
  };

  const removePhoneNumberField = async (index) => {
    const confirmDelete = window.confirm(
      "Weet je zeker dat je dit telefoonnummer wilt verwijderen?"
    );
    if (confirmDelete) {
      const phoneNumberToRemove = phoneNumbers[index];

      if (phoneNumberToRemove.phone_number_id) {
        // Only delete if the phone number has an ID
        try {
          await middleware.delete(
            `phonenumbers?phone_number_id=${phoneNumberToRemove.phone_number_id}`
          );
          ToastSuccess("Telefoonnummer succesvol verwijderd!");
          setConsumerInfoUpdated(true);
        } catch (error) {
          console.error("Error deleting phone number:", error);
          ToastError(
            "Er is een fout opgetreden bij het verwijderen van het telefoonnummer."
          );
          return;
        }
      }

      // Update state after successful deletion
      const newPhoneNumbers = phoneNumbers.filter((_, i) => i !== index);
      setPhoneNumbers(newPhoneNumbers);
      setFormData((prev) => ({
        ...prev,
        phone_numbers: newPhoneNumbers,
      }));
    }
  };

  const handleEmailSettingsChange = async (settingKey, value) => {
    const updatedSettings = { ...emailSettings, [settingKey]: value ? 1 : 0 };
    setEmailSettings(updatedSettings);

    const res = await middleware.get(
      `emailsettings?internal_id=${internal_id}`
    );

    if (!res.data.length) {
      await middleware.put(
        `emailsettings?internal_id=${internal_id}`,
        updatedSettings
      );
    } else {
      try {
        await middleware.put(
          `emailsettings?internal_id=${internal_id}`,
          updatedSettings
        );
        ToastSuccess("Voorkeur successvol veranderd!");
      } catch (error) {
        console.error(
          "Er ging iets fout met het veranderen van de voorkeur:",
          error
        );
        ToastError("Er ging iets fout met het veranderen van de voorkeur");
      }
    }
  };
  const handleEditClick = (row) => {
    setRowToEdit(row);
    setShowAddContactsModal(true);
  };
  const handleDeleteClick = async (row) => {
    const confirm = window.confirm(
      "Weet je zeker dat je deze contactpersoon wil verwijderen?"
    );
    if (confirm) {
      await middleware.delete(
        `businessescontacts?business_contact_id=${row.business_contact_id}`
      );
      fetchContacts();
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: () => <div className="fw-bold">Naam</div>,
        accessor: "firstName",
        Cell: ({ row }) => {
          return (
            <div className="d-flex flex-column">
              <p
                className="mb-0 text-nowrap text-center cursorPointer"
                onClick={() => { handleEditClick(row.original) }}
                style={{ color: "#009fe3" }}
              >
                {`${row.original.first_name} ${row.original.last_name}`}
              </p>
            </div>
          );
        },
      },
      {
        Header: () => <div className="text-center fw-bold">Geboortedatum</div>,
        accessor: "birthDay",
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              <p className="mb-0">{row.original.birthday}</p>
            </div>
          );
        },
      },
      {
        Header: () => "",
        accessor: "Edit",
        Cell: ({ row }) => {
          return (
            <div className="d-flex flex-column">
              <img
                className="trashImg"
                onClick={() => handleEditClick(row.original)}
                src={editIcon}
              />
            </div>
          );
        },
      },
      {
        Header: () => "",
        accessor: "Delete",
        Cell: ({ row }) => {
          return (
            <div className="d-flex flex-column">
              <img
                className="trashImg"
                onClick={() => handleDeleteClick(row.original)}
                src={Trash}
              />
            </div>
          );
        },
      },
    ],
    [consumerData]
  );

  const tableInstance = useTable({
    columns,
    data: consumerData.length ? consumerData : [],
  });

  if (loading) {
    return <h2 className="m-4 loader"></h2>;
  }

  return (
    <div className="px-4 py-4">
      <form className="col-12" ref={formRef}>
        {typeCustomer === "B" && (
          <div>
            <label className="fw-bold mb-2 secondaryTitles">
              Bedrijfsgegevens
            </label>
            <div className="col-12 d-flex flex-row align-content-end mb-3">
              <BorderedTextInput
                label={"Bedrijfsnaam"}
                size="l"
                inputValue={formData.business.company_name}
                setInputValue={(value) => getValueInput(value, "company_name")}
                updateFunction={handleSubmit}
              />
            </div>
            <div className="col-12 d-flex flex-row gap-4 align-content-end mb-4">
              <BorderedTextInput
                label={"KVK nummer"}
                size="l"
                inputValue={formData.business.cocnumber === 0 ? "" : formData.business.cocnumber}
                setInputValue={(value) => {
                  if (/^(\d{1,6}\/?(\d{1,12})?)?$/.test(value))
                    getValueInput(value === "" ?  ""  : value , "cocnumber")
                }
                }
                updateFunction={handleSubmit}
                updateWaitTimer={2500}
              />
              <BorderedTextInput
                label={"BTW nummer"}
                size="l"
                inputValue={formData.business.vatnumber}
                setInputValue={(value) => {
                  getValueInput(value.toUpperCase(), "vatnumber")
                }}
                updateFunction={handleSubmit}
                updateWaitTimer={2500}
              />
            </div>
          </div>
        )}

        <AddContactsModal
          rowToEdit={rowToEdit}
          setRowToEdit={setRowToEdit}
          openAddContacts={showAddContactsModal}
          setUpdatedContacts={setUpdatedContacts}
          closeAddContacts={() => setShowAddContactsModal(false)}
        />
        <div>
          {typeCustomer === "C" && (
            <>
              <div className="InputRow">
                <BorderedTextInput
                  inputValue={formData.consumer.first_name}
                  setInputValue={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      consumer: {
                        ...prev.consumer,
                        first_name: value,
                      },
                    }))
                  }
                  updateFunction={handleSubmit}
                  label="Voornaam"
                  size="l"
                  placeholder="Voornaam"
                />
                <BorderedTextInput
                  inputValue={formData.consumer.last_name}
                  setInputValue={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      consumer: {
                        ...prev.consumer,
                        last_name: value,
                      },
                    }))
                  }
                  updateFunction={handleSubmit}
                  label="Achternaam"
                  size="l"
                  placeholder="Achternaam"
                />
              </div>
            </>
          )}
          <div className="col-12 d-flex flex-row align-content-end my-3">
            <div className="d-flex flex-column col-6 pe-3">
              <div className="d-flex justify-content-between">
                <label className="mb-2">E-mailadres</label>
                <img
                  className="pe-3 addIconSizeModals"
                  src={Plus}
                  onClick={addEmailField}
                  alt="Add"
                  style={{ cursor: "pointer" }}
                />
              </div>
              {emails.map((email, index) => (
                <div key={index} className="d-flex align-items-center mb-2">
                  <BorderedTextInput
                    size="l"
                    inputValue={email.email || ""}
                    setInputValue={(value) => handleEmailChange(index, value)}
                    updateFunction={handleSubmit}
                    updateWaitTimer={2000}
                  />
                  <img
                    className="ms-2 removeIconSizeModals"
                    src={Minus}
                    onClick={() => removeEmailField(index)}
                    alt="Remove"
                    style={{ cursor: "pointer", width: "3%" }}
                  />
                </div>
              ))}
            </div>
            <div className="d-flex flex-column col-6 ps-3">
              <div className="d-flex justify-content-between">
                <label className="mb-2">Telefoonnummer</label>
                <img
                  className="pe-3 addIconSizeModals"
                  src={Plus}
                  onClick={addPhoneNumberField}
                  alt="Add"
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div>
                <div className="d-flex flex-column gap-2">
                  {phoneNumbers.map((phoneNumber, index) => (
                    <Phonenumber
                      key={index}
                      index={index}
                      phonenumber={phoneNumber}
                      setPhoneCode={(value) => setPhoneCode(index, value)}
                      handlePhoneNumberChange={(newNum) => {
                        setPhoneNumbers((prevNums) => {
                          const updatedNums = [...prevNums];
                          updatedNums[index].phone_number = newNum;
                          return updatedNums;
                        });
                      }}
                      removePhoneNumberField={() => removePhoneNumberField(index)}
                      removable={true}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 d-flex flex-row align-content-end my-3">
            {typeCustomer === "C" && (
              <InputComponent
                type={"date"}
                onValueChange={getValueInput}
                onBlur={handleSubmit}
                parentCol={6}
                defaultValue={consumerData?.birthday || ""}
                labelValue={"birthday"}
                labelName={"Geboortedatum"}
                classnamesInput={"col-12 widthInputComponents px-3"}
              />
            )}
            <div className="col-6 d-flex justify-content-start ps-3">
              {/*<div className="col-4 d-flex flex-column">*/}
              {/*  <label className="mb-2 fw-medium fw-semibold">*/}
              {/*    Nieuwsbrief*/}
              {/*  </label>*/}
              {/*  <label className="switchNewCustomer">*/}
              {/*    <input*/}
              {/*      type="checkbox"*/}
              {/*      checked={emailSettings?.newsletter === 1}*/}
              {/*      onChange={(e) =>*/}
              {/*        handleEmailSettingsChange("newsletter", e.target.checked)*/}
              {/*      }*/}
              {/*    />*/}
              {/*    <span className="sliderNewCustomer round"></span>*/}
              {/*  </label>*/}
              {/*</div>*/}
              <div className=" col-4 d-flex flex-column">
                <label className="mb-2 fw-semibold">Verjaardagactie</label>
                <label className="switchNewCustomer">
                  <input
                    type="checkbox"
                    checked={emailSettings?.birthday_promotion === 1}
                    onChange={(e) =>
                      handleEmailSettingsChange(
                        "birthday_promotion",
                        e.target.checked
                      )
                    }
                  />
                  <span className="sliderNewCustomer round"></span>
                </label>
              </div>
            </div>
          </div>
          {typeCustomer === "B" && (
            <>
              <label
                className={`fw-bold mb-2 secondaryTitles ${typeCustomer === "B" ? "" : "d-none"
                  }`}
              >
                Contactpersonen
                <span
                  className="p-2"
                  role="button"
                  onClick={() => setShowAddContactsModal(true)}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </span>
              </label>
              <div className="px-0 tableContacts">
                <TablePreset
                  data={[
                    {
                      tableInstance: tableInstance,
                      pagination: pagination,
                      primary_key: "business_contact_id",
                    },
                  ]}
                  setPagination={setPagination}
                  handleSelection={() => { }}
                  noCheckbox={true}
                />
              </div>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default GeneralInfoTab;
